import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getSidemenu } from '../api/permission.api';
import { ISidemenu, IGetSidemenu } from '../models/permission.model';

interface ISidemenuState {
  sidemenu: ISidemenu[];
  isLoading: boolean;
  error?: AxiosError | string;
}

const initialState: ISidemenuState = {
  sidemenu: [],
  isLoading: false,
};

const sidemenuSlicer = createSlice({
  name: 'sidemenu',
  initialState,
  reducers: {
    getSidemenuStart: (state: ISidemenuState) => {
      state.sidemenu = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getSidemenuSuccess: (
      state: ISidemenuState,
      action: PayloadAction<IGetSidemenu>,
    ) => {
      state.sidemenu = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getSidemenuFailure: (
      state: ISidemenuState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.sidemenu = [];
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { getSidemenuStart, getSidemenuSuccess, getSidemenuFailure } =
  sidemenuSlicer.actions;

export default sidemenuSlicer.reducer;

export const doGetSidemenu = (): any => async (dispatch: any) => {
  try {
    dispatch(getSidemenuStart());
    const response = await getSidemenu();
    dispatch(getSidemenuSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getSidemenuFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
